import React from 'react';

export const OHIFLogo = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <img
      src="/assets/logo_kura.png"
      alt="Kura Logo"
      style={{ height: '32px', width: 'auto', display: 'block' }}
    />
    <span
      style={{
        fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
        fontSize: '18px',
        fontWeight: 700,
        letterSpacing: '0.15em',
        color: '#ffffff',
        lineHeight: 1,
        userSelect: 'none',
      }}
    >
      KURA
    </span>
  </div>
);

export default OHIFLogo;
